import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        accessToken: null,
        refreshToken: null,

        userInfo: {
            name: "",
            email: "",
            pk: "",
        }
    },
    mutations: {
        SET_TOKEN(state, { accessToken, refreshToken }) {
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
        },
        DEL_TOKEN(state) {
            console.log("DEL_TOKEN");
            console.log(state);
            state.accessToken = null;
            state.refreshToken = null;
        },

        SET_USERINFO(state, { name, email, pk }) {
            state.userInfo.name = name;
            state.userInfo.email = email;
            state.userInfo.pk = pk;
        },
        DEL_USERINFO(state) {
            state.userInfo.name = "";
            state.userInfo.email = "";
            state.userInfo.pk = "";
        }
    },

    // * What is vuex-persistedstate?
    // - Vuex store state값은 새로고침 시 초기화 된다.
    // - 위의 상황을 방지하고자 모든 state 값의 변경사항을 localstorage에서 관리.
    plugins: [createPersistedState()]
});
